'use client';

import type { FC } from 'react';
import { Card, type CardProps, P } from '@paypoteam/ui-components';
import parse from 'html-react-parser';

import { cn } from '@/lib/utils';

export interface OrderedCardTemplateProps extends Omit<CardProps, 'children'> {
    number: string | number;
    numberBgColor: string;
    content: string;
    'data-test-id'?: string;
}

const OrderedCardTemplate: FC<OrderedCardTemplateProps> = ({
    number,
    numberBgColor,
    content,
    className,
    ...cardProps
}) => (
    <Card
        variant={'shadow'}
        size={'l'}
        className={cn('mx-1 my-4 h-full lg:m-0', className)}
        {...cardProps}
    >
        <div className="flex flex-col items-start gap-4 self-stretch">
            <div className="relative flex h-8 w-8 items-center justify-center">
                <span
                    className={`h-8 w-8 flex-shrink-0 rotate-45 ${numberBgColor}`}
                />

                <div className="absolute text-center leading-5 text-white">
                    {number}
                </div>
            </div>

            <P className="self-stretch text-2xs md:text-sm">{parse(content)}</P>
        </div>
    </Card>
);

export default OrderedCardTemplate;
